module.exports = __webpack_public_path__ + "static/media/modelA2.41a1b6cc.gif";